import React, {useEffect, useState} from 'react'
import {OrderHeader} from '../../componentsv1'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {ViewOrder} from '../../models/OrderState'
import {
  fetchOrder,
  selectViewOrder,
  resetOrderState,
  selectOrderIsFetching
} from '../../redux/order/orderSlice'
import {useLocation, useParams} from 'react-router-dom'
import {formatToDateString4} from 'app/format/date'
import capitalize from 'lodash/capitalize'
import lowerCase from 'lodash/lowerCase'
import Loader from '../../componentsv1/shared/Loader'
import OrderToolbar from './OrderToolbar'
import {PAYMENT_TYPES} from 'app/constant/payment'

interface Props {
  children: React.ReactNode
}

export const OrderWrapper: React.FC<Props> = ({children}) => {
  const {orderId}: any = useParams<any>()

  const dispatch = useDispatch()
  const order = useSelector<RootState, ViewOrder>(selectViewOrder)
  const isFetching = useSelector<RootState, boolean>(selectOrderIsFetching)
  const location = useLocation()
  const {state} = location
  const [breadCrumbs, setBreadCrumbs] = useState<any>({})

  useEffect(
    () => () => {
      dispatch(resetOrderState())
    },
    [dispatch]
  )

  useEffect(() => {
    if (orderId) {
      dispatch(fetchOrder(orderId))
    }
  }, [orderId, dispatch])

  useEffect(() => {
    if (state) {
      let breadCrumbs: any[] = []
      if (state.wineClubPackageViewBreadCrumbs) {
        breadCrumbs = state.wineClubPackageViewBreadCrumbs
      } else if (state.customerBreadCrumbs) {
        breadCrumbs = state.customerBreadCrumbs
      } else if (state.isWineClubOrder && state.route) {
        breadCrumbs = [{path: state.route}]
      } else if (state?.redirectURL) {
        breadCrumbs = [
          {path: state?.redirectURL, locationState: {prevRedirectURL: state?.redirectURL}},
        ]
      } else if (state?.prevRedirectURL) {
        breadCrumbs = [
          {path: state?.prevRedirectURL, locationState: {prevRedirectURL: state?.prevRedirectURL}},
        ]
      } else {
        breadCrumbs = [{path: '/orders'}]
      }
      setBreadCrumbs(breadCrumbs)
    } else {
      setBreadCrumbs([{path: '/orders'}])
    }
  }, [state])

  if (isFetching) {
    return <Loader />
  }

  if (!order) {
    return <div>Order not found</div>
  }

  return (
    <>
      <OrderHeader
        title={`#${order?.orderNumber}`}
        routePath={breadCrumbs[0]?.path}
        fulfillmentStatus={order.fulfillmentStatus}
        paymentStatus={order.financialStatus}
        locationState={breadCrumbs[0]?.locationState}
        subTitle={
          <div className='text-muted fs-7 fw-bold pt-2'>
            {formatToDateString4(order.createdAt)} Placed order via{' '}
            {capitalize(lowerCase(order.orderType).trim())}{' '}
            {order.paymentType && (
              <>
                {order.paymentType === PAYMENT_TYPES.scanner && order.terminalName
                  ? `(${capitalize(order.paymentType)}: ${capitalize(order.terminalName)})`
                  : `(${capitalize(order.paymentType)})`}
              </>
            )}
          </div>
        }
      >
        <OrderToolbar />
      </OrderHeader>
      {children}
    </>
  )
}

export default OrderWrapper
